import { css, styled } from "styled-components";

import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const Container = styled.div`
  width: 100%;
  overflow-x: auto;
  display: flex;
  justify-content: center;

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    justify-content: unset;
  }
`;

export const Buttons = styled.div<{ $isSpotlight?: boolean }>`
  display: flex;
  background: ${({ theme }) => theme.colors.neutral02};
  border-radius: 8px;
  gap: 12px;
  width: fit-content;
  padding: 2px;
  margin-bottom: 24px;

  ${({ $isSpotlight }) =>
    $isSpotlight &&
    css`
      margin-right: 10px;
    `}
`;

export const Button = styled.button<{
  $isActive: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: ${({ theme }) => theme.colors.neutral09};
  padding: 4px 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: ${({ theme }) => theme.colors.neutral00};
      color: ${({ theme }) => theme.colors.ublue06};
    `}
`;

export const ButtonCopy = styled.span`
  white-space: nowrap;
`;
